export default {
  state: {
    productList: [],
    brandList: []
  },
  mutations: {
    setProductList (state, payload) {
      state.productList = payload
    },
    setBrandList (state, payload) {
      state.brandList = payload
    }
  },
  actions: {
    getProductList ({commit, dispatch}) {
      const url = '/admin/product/tree?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setProductList', data.product_category_list)
        })
        .catch((error) => {
          throw error
        })
    },
    async getProductCategoryList ({commit, dispatch}) {
      let returnData
      const url = '/admin/product/category/list?access_token=' + this.getters.accessToken
      await dispatch('apiGet', url)
        .then((data) => {
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    async getProductBrandList ({commit, dispatch}, {id}) {
      let returnData
      const url = '/admin/product/category/brand/list?access_token=' + this.getters.accessToken + '&product_category_id=' + id
      await dispatch('apiGet', url)
        .then((data) => {
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    async getProductSkuList ({commit, dispatch}, {id}) {
      let returnData
      const url = '/admin/product/sku/list?access_token=' + this.getters.accessToken + '&product_category_brand_id=' + id
      await dispatch('apiGet', url)
        .then((data) => {
          returnData = data
        })
        .catch((error) => {
          throw error
        })
      return returnData
    },
    async getBrandList ({commit, dispatch}) {
      const url = '/admin/product/brand/list?access_token=' + this.getters.accessToken
      await dispatch('apiGet', url)
        .then((data) => {
          commit('setBrandList', data.product_brand_list)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    productList (state) {
      return state.productList
    },
    brandList (state) {
      return state.brandList
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/product.js